import { AdminShell } from '@/components/layout/AdminShell'
import { PageHeader } from '@/components/landing/PageHeader'
import { StatCard } from '@/components/dashboard/StatCard'
import { Building2, Users, AppWindow, DoorOpen, Activity, ShieldOff, UserX, Zap } from 'lucide-react'

interface Stats {
  total_organizations: number
  total_users: number
  total_applications: number
  total_rooms: number
  active_rooms: number
  suspended_orgs: number
  suspended_users: number
  recent_events: number
}

interface Props {
  admin: { email: string }
  stats: Stats
}

export default function Overview({ admin, stats }: Props) {
  return (
    <AdminShell admin={admin}>
      <div className="space-y-8">
        <PageHeader
          eyebrow="Admin · platform"
          title="System Overview"
          description="Platform-wide metrics and health."
        />

        <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
          <StatCard
            title="Organizations"
            value={stats.total_organizations}
            icon={<Building2 className="h-4 w-4" />}
          />
          <StatCard
            title="Users"
            value={stats.total_users}
            icon={<Users className="h-4 w-4" />}
          />
          <StatCard
            title="Applications"
            value={stats.total_applications}
            icon={<AppWindow className="h-4 w-4" />}
          />
          <StatCard
            title="Total Rooms"
            value={stats.total_rooms}
            icon={<DoorOpen className="h-4 w-4" />}
          />
          <StatCard
            title="Active Rooms"
            value={stats.active_rooms}
            icon={<Activity className="h-4 w-4" />}
          />
          <StatCard
            title="Suspended Orgs"
            value={stats.suspended_orgs}
            icon={<ShieldOff className="h-4 w-4" />}
          />
          <StatCard
            title="Suspended Users"
            value={stats.suspended_users}
            icon={<UserX className="h-4 w-4" />}
          />
          <StatCard
            title="Events (30d)"
            value={stats.recent_events}
            icon={<Zap className="h-4 w-4" />}
          />
        </div>
      </div>
    </AdminShell>
  )
}
